"use strict";

$(document).ready(function () {
  if ($('body#product').length > 0) {
    innerProductGallery();
    tabsInner();
    carouselInner();
    selectInner();
  }

  $(document).on('click', '.label-color.radio_container', function () {
    setTimeout(function () {
      innerProductGallery();
    }, 600);
  });
  $('#checkout-addresses-step select.address-select').select2({
    minimumResultsForSearch: -1
  });
  $('#amazzing_filter select.af-select').select2({
    minimumResultsForSearch: -1
  });
  $('#topic_select').select2({
    minimumResultsForSearch: -1
  });

  if ($('#venipak-additional-info select').length > 0) {
    var venipak_additional_info = $('#venipak-additional-info select').select2({
      minimumResultsForSearch: -1
    });
  }

  $(document).on('change', function () {
    setTimeout(function () {
      if ($('#module-mpreturns-returns select.shops-select').length > 0) {
        $('select.shops-select').select2({
          minimumResultsForSearch: -1
        });
      }

      if ($('#venipak-additional-info select').length > 0) {// var venipak_additional_info = $('#venipak-additional-info select').select2({
        //     minimumResultsForSearch: -1,
        // });
        // console.log(venipak_additional_info);
        // $(document).on('click', '#venipak-additional-info select', function(){
        //     $('.select2-dropdown').addClass('change-blue-select');
        // });
      }

      if ($('.sort-by-row select.custom-select').length > 0) {
        $('.sort-by-row select.custom-select').select2({
          minimumResultsForSearch: -1
        });
      }

      if ($('#checkout-addresses-step select.address-select').length > 0) {
        $('select.custom-select').select2({
          minimumResultsForSearch: -1
        });
      }

      if ($('#address select.address-select').length > 0) {
        $('select.custom-select').select2({
          minimumResultsForSearch: -1
        });
      }

      if ($('#amazzing_filter select.af-select').length > 0) {
        $('#amazzing_filter select.af-select').select2({
          minimumResultsForSearch: -1
        });
      }

      if ($('.has-compact-filter select.custom-select').length > 0) {
        $('.has-compact-filter select.custom-select').select2({
          minimumResultsForSearch: -1
        });
      }

      if ($('#prices-drop select.custom-select').length > 0) {
        $('#prices-drop select.custom-select').select2({
          minimumResultsForSearch: -1
        });
      }

      if ($('#topic_select').length > 0) {
        $('#topic_select').select2({
          minimumResultsForSearch: -1
        });
      }
    }, 800);
  });
  $('.open_popup.quick-view').on('click', function () {
    setTimeout(function () {
      $('select.custom-select').select2({
        minimumResultsForSearch: -1
      });
      innerProductGallery(); // if(($('.quickview .product-discount .regular-price').length > 0) && ($('.quickview .current-price .current-price-display.current-price-discount').length > 0)){
      //     var regular = $('.quickview .product-discount .regular-price').attr('content').split(/[x^ ]/);
      //     regular = regular[0].replace(/,/g, '.');
      //     var now = $('.quickview .current-price .current-price-display.current-price-discount').attr('content').split(/[x^ ]/);
      //     now = now[0].replace(/,/g, '.');
      //     var percentage = parseInt((parseFloat(now) / parseFloat(regular)) * 100);
      //
      //     if((typeof percentage == 'number') && $('.quickview .product-flags .discount-badge').length > 0) {
      //         $('.quickview .product-flags .discount-badge').text('-' + (100 - percentage) + '%');
      //     }
      // }
    }, 600);
  });
  prestashop.on('updatedProduct', function (event) {
    selectProductInner();

    if ($('body#product').length > 0) {
      innerProductGallery();
    }
  });
});

function selectProductInner() {
  $('.product-variants-item select').select2({
    minimumResultsForSearch: -1
  });
}

function innerProductGallery() {
  var breakpoint = window.matchMedia('(max-width: 1151px)');

  var breakpointChecker = function breakpointChecker() {
    if (breakpoint.matches === true) {
      return mobileSwiper();
    } else if (breakpoint.matches === false) {
      return desktopSwiper();
    }
  };

  var desktopSwiper = function desktopSwiper() {
    var galleryThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 13,
      slidesPerView: 5,
      slideToClickedSlide: true,
      // direction: 'vertical',
      centeredSlides: false,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 4,
          direction: 'horizontal'
        },
        // when window width is >= 768px
        768: {
          slidesPerView: 5,
          direction: 'vertical'
        }
      }
    });
    var galleryTop = new Swiper('.inner_product_gallery', {
      // spaceBetween: 10,
      navigation: {
        nextEl: '.image_gallery .swiper-button-next',
        prevEl: '.image_gallery .swiper-button-prev'
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  };

  var mobileSwiper = function mobileSwiper() {
    var galleryThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 10,
      slidesPerView: 5,
      slideToClickedSlide: true,
      direction: 'horizontal',
      centeredSlides: false
    });
    var galleryTop = new Swiper('.inner_product_gallery', {
      spaceBetween: 10,
      navigation: {
        nextEl: '.image_gallery .swiper-button-next',
        prevEl: '.image_gallery .swiper-button-prev'
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  };

  breakpoint.addListener(breakpointChecker);
  breakpointChecker(); // if($(window).width() > 1051) {
  //     desktopSwiper();
  // } else {
  //     mobileSwiper();
  // }
}

function tabsInner() {
  var tab = $('.tabs-container .tabs .tab');
  tab.on('click', function () {
    // if ($(this).hasClass('active')) {
    //     return;
    // } else {
    //     $(this).addClass('active');
    //     $(this).siblings().removeClass('active');
    //
    //     var targetId = $(this).data('tab');
    //     var target = $(".tabs-wrapper, main").find("[data-tab-container*='" + targetId + "']");
    //
    //     target.siblings().removeClass('active');
    //     target.removeClass('active');
    //
    //     setTimeout(function () {
    //         target.siblings().addClass('none');
    //         target.addClass('none');
    //         target.removeClass('none');
    //
    //         if (targetId === 'all') {
    //             $('.tabs-wrapper .content-container').addClass('all-active');
    //         } else {
    //             $('.tabs-wrapper .content-container').removeClass('all-active');
    //         }
    //     }, 300)
    //
    //     target.addClass('active');
    // }
    if (!$(this).hasClass('active')) {
      var thisEl = $(this);
      var thisId = thisEl.attr('data-tab');
      var parentHolder = thisEl.parents('.tabs-wrapper');
      var thisContentBlock = parentHolder.find('.content-container .content[data-tab-container="' + thisId + '"]');
      $('.tabs-container .tabs .tab').not(thisEl).removeClass('active');
      $(this).addClass('active');
      $('.tabs-wrapper .content-container .content').not(thisContentBlock).removeClass('active').addClass('none');
      thisContentBlock.removeClass('none').addClass('active');
    }
  });
  var accordionItem = $('.tabs-wrapper .mobile-accordion .item .heading-wrapper');
  accordionItem.on('click', function () {
    if ($(this).parents('.item').hasClass('opened')) {
      $(this).parents('.item').removeClass('opened');
      $(this).siblings('.content-wrapper').slideUp();
    } else {
      $(this).parents('.item').addClass('opened');
      $(this).siblings('.content-wrapper').slideDown();
    }
  });
}

function carouselInner() {
  var trigger = $('.cities_list .city .heading');
  trigger.on('click', function () {
    if ($(this).parents('.city').hasClass('active')) {
      $(this).parents('.city').removeClass('active');
      $(this).parents('.city').children('.shops').slideUp();
    } else {
      $(this).parents('.city').addClass('active');
      $(this).parents('.city').children('.shops').slideDown();
    }
  });
}

function selectInner() {
  $('.product-variants-item .custom-select').select2({
    minimumResultsForSearch: -1
  });
}